import script from "./ParentAttestationConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParentAttestationConsent.vue?vue&type=script&setup=true&lang=ts"

import "./ParentAttestationConsent.vue?vue&type=style&index=0&id=efa5a154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efa5a154"]])

export default __exports__